<div class="stripe-container">
  <div *ngIf="status === 'pending'" class="card pending">
    <div class="spinner"></div>
    <h2>Obrada uplate...</h2>
    <p>Molimo sačekajte dok potvrđujemo vašu uplatu.</p>
    <div class="dots">
      <span></span><span></span><span></span>
    </div>
  </div>

  <div *ngIf="status === 'success'" class="card success">
    <div class="icon">&#10004;</div>
    <h2>Uspešno ste uplatili paket!</h2>
    <p>Vaša uplata je uspešno evidentirana.</p>
    <!-- <button (click)="goToDashboard()">Idi na dashboard</button> -->
  </div>

  <div *ngIf="status === 'error'" class="card error">
    <div class="icon">&#10060;</div>
    <h2>Došlo je do greške</h2>
    <p>Došlo je do problema prilikom evidentiranja uplate.</p>
    <!-- <button (click)="retry()">Pokušaj ponovo</button> -->
  </div>
</div>
